// dashboardgraph.tsx
import React from "react";
import StockBarGraph from "./GraphComponents/StockBarGraph";
import StockDonutChart from "./GraphComponents/StockDonutChart";

const StockDashboardGraphs: React.FC = () => {
  return (
    <div className="flex flex-col lg:flex-row gap-4 w-full max-w-full">
      {/* Bar Chart: Month Wise Stock Quantity */}
      <div className="xl:w-1/2 lg:w-1/2 w-full border-2 border-gray-300 rounded-lg p-5">
        <div className="flex justify-between mb-4">
          <span className="font-semibold">Month Wise Stock Quantity</span>
        </div>
        <div className="w-full h-48"> {/* Fixed height for bar chart */}
          <StockBarGraph className="w-full h-full" />
        </div>
      </div>

      {/* Donut Chart: Total Stock Quantity */}
      <div className="xl:w-1/2 lg:w-1/2 w-full border-2 border-gray-300 rounded-lg p-5">
        <StockDonutChart />
      </div>
    </div>
  );
};

export default StockDashboardGraphs;
